import { createFileRoute } from '@tanstack/react-router';
import CongregationList from '~/containers/CongregationList';

export const Route = createFileRoute('/congregations/')({
  component: CongregationList,
  validateSearch(search) {
    return {
      page: search.page !== undefined ? Number(search.page) : undefined,
    };
  },
});
